'use strict';
var $ = require('../internals/export');
var sign = require('../internals/math-sign');

// `Math.sign` method
// https://tc39.es/ecma262/#sec-math.sign
$({ target: 'Math', stat: true }, {
  sign: sign
});



//////////////////
// WEBPACK FOOTER
// ./~/core-js/modules/es.math.sign.js
// module id = 772
// module chunks = 0